$(document).ready(function () {
    let $contentCardsSection = $(".content-04-section.-show-more-block");
    let $contentCards = $(".content-04-section.-show-more-block .content-cards");

    if ($contentCards.length > 0) {
        let fullHeight = 0;
        let visibleHeight = 0;

        $("#expandBtn").click(function (e) {
            e.preventDefault();
            fullHeight = $contentCards.prop("scrollHeight");
            visibleHeight = $contentCards[0].scrollHeight > $contentCards.outerHeight() ? $contentCards.outerHeight() : $contentCards[0].scrollHeight;
            $contentCardsSection.addClass("-open");
            $(this).fadeOut(200);
            $contentCards.animate({ maxHeight: fullHeight + "px" }, 200, function () {
                $contentCards.css("max-height", fullHeight + "px");
                $("#сollapseBtn").css("display", "inline-flex");
                $(this).closest(".button-box").find(".overflow").fadeOut();
            });
        });

        $("#сollapseBtn").click(function (e) {
            e.preventDefault();
            $contentCardsSection.removeClass("-open");
            $(this).closest(".button-box").find(".overflow").fadeIn();
            $(this).css("display", "none");
            $("#expandBtn").css("display", "inline-flex");
            // $contentCards.animate({ maxHeight: visibleHeight + "px" }, 100, function () {
                $contentCards.css("max-height", visibleHeight + "px");
            // });

            let scrollTop = ($contentCards.offset().top + visibleHeight - 300);
            $('html, body').animate({
                scrollTop: scrollTop
            }, 400);

        });

        let prevWidth = $(window).width();

        $(window).on('resize', function () {
            const currentWidth = $(window).width();

            if (currentWidth !== prevWidth) {
                $contentCardsSection.removeClass("-open");
                $contentCards.removeAttr('style');
                $("#сollapseBtn").closest(".button-box").find(".overflow").fadeIn();
                $("#сollapseBtn").css("display", "none");
                $("#expandBtn").css("display", "inline-flex");

                prevWidth = currentWidth;
            }
        });
    }
});